export enum SystemEnum {
  WEB = 'web',
  TABLET = 'tablet',
}
